export const NONE = '_none_';
export const CONNECTING = '_connecting_';
export const CONNECTED = '_connected_';
export const ONGOING = '_ongoing_';
export const DISCONNECTED = '_disconnected_';
export const FAILED = '_failed_';
export const TERMINATED = '_terminated_';
